<template>
  <form class="form p-2 border border-gray-1 bg-light" @submit.prevent>
    <select class="form-select mb-2" v-model="selectedMake">
      <option v-for="make in makes" :key="make.id" :value="make.id">{{
        make.name
      }}</option>
    </select>

    <select class="form-select mb-2" v-model="selectedCountryCriteriaType">
      <option
        :selected="selectedCountryCriteriaType == countryCriteriaTypes.MARKET"
        :value="countryCriteriaTypes.MARKET"
        >Statistics by Market</option
      >
      <option
        :selected="selectedCountryCriteriaType == countryCriteriaTypes.CLIENT"
        :value="countryCriteriaTypes.CLIENT"
        >Statistics by Client location</option
      >
    </select>
    <select class="form-select mb-2" v-model="selectedCountry">
      <option
        v-for="country in countries"
        :key="country.id"
        :value="country.id"
        >{{ country.name }}</option
      >
    </select>

    <select class="form-select mb-2" v-model="selectedYear">
      <option v-for="year in years" :key="year.id" :value="year.id">{{
        year.name
      }}</option>
    </select>
    <select
      class="form-select mb-2"
      v-model="selectedQuartal"
      v-if="selectedYear != -1"
    >
      <option value="-1">Whole year</option>
      <option value="1">Quartal 1</option>
      <option value="2">Quartal 2</option>
      <option value="3">Quartal 3</option>
      <option value="4">Quartal 4</option>
    </select>

    <button class="btn btn-primary w-100" @click="onLoadStatistics">
      Show statistics
    </button>
  </form>
</template>

<script>

export default {
  props: {
    onResponse: {
      type: Function,
      default: () => {},
    },
    immediate: {
      type: Boolean
    }
  },
  data() {
    return {
      makes: [],
      models: [],
      countries: [],
      countryCriteriaTypes: {
        CLIENT: "client",
        MARKET: "search",
      },
      years: [],
      quartals: [],

      selectedMake: -1,
      selectedCountry: -1,
      selectedYear: -1,
      selectedQuartal: -1,
      selectedCountryCriteriaType: null,

      items: [],
    };
  },
  async created() {
    this.selectedCountryCriteriaType = this.countryCriteriaTypes.MARKET;
    this.countries = await this.getCountries(this.selectedCountryCriteriaType);
    this.years = await this.getYears();
    this.makes = await this.getMakes();
    await this.loadStatistics();
    if (this.immediate) {
      this.onResponse(this.items);
    }
  },
  methods: {
    async getYears() {
      const years = await this.$api.get("meta", {
        type: "year",
      });
      return [{ id: -1, name: "Year" }, ...years.data];
    },
    async getMakes() {
      const makes = await this.$api.get("meta", {
        type: "make",
      });
      return [{ id: -1, name: "Make" }, ...makes.data];
    },
    async getCountries(countryCriteriaType) {
      const countries = await this.$api.get("meta", {
        type: "country",
        countryCriteriaType,
      });
      return [{ id: -1, name: "Country" }, ...countries.data];
    },
    getParams() {
      const params = {
        top: 30,
      };
      if (this.selectedMake > -1) {
        params.idMake = this.selectedMake;
      }
      if (this.selectedCountry > -1) {
        params.idCountry = this.selectedCountry;
        params.countryCriteriaType = this.selectedCountryCriteriaType;
      }
      if (this.selectedYear > -1) {
        params.year = this.selectedYear;
        if (this.selectedQuartal > -1) {
          params.quartal = this.selectedQuartal;
        }
      }
      return params;
    },
    async loadStatistics() {
      const endpoint = this.selectedMake > -1 ? "report/model" : "report/make";
      const items = await this.$api.get(endpoint, this.getParams());
      this.items = items.data.map((item, index) => {
        return {
          ...item,
          ord: index + 1,
          name: this.selectedMake > -1 ? item.model : item.make,
          percentFixed: item.percent.toFixed(2),
          percentDisplay: `${item.percent.toFixed(2)} %`,
        };
      });
    },
    async onLoadStatistics() {
      await this.loadStatistics();
      this.onResponse(this.items);
    }
  },
  watch: {
    async selectedCountryCriteriaType(value) {
      this.countries = await this.getCountries(value);
      this.selectedCountry = -1;
    },
    selectedYear(value) {
      if (value == -1) {
        this.selectedQuartal = -1;
      }
    },
  },
};
</script>
